import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils';
import type { TrackingSite } from '@hotjar/webapp/tracking/utils';
import { tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';
import type { USER_GOALS, USER_EXPERTISE } from './types';

interface UsecaseSubmittedArgs {
  site?: TrackingSite;
  usecase: USER_GOALS;
}

export const trackUsecaseSubmitted = ({ usecase, site }: UsecaseSubmittedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(usecase && { user_usecase: usecase }),
  };

  tagRecording('usecase_submitted');
  Segment.track('Use-case submitted', data);
};

interface ExpertiseSubmittedArgs {
  site?: TrackingSite;
  expertise: USER_EXPERTISE;
}

export const trackExpertiseSubmitted = ({ expertise, site }: ExpertiseSubmittedArgs): void => {
  const data = {
    ...(site && extractSiteGroupingProps(site)),
    ...(expertise && { user_expertise: expertise }),
  };

  tagRecording('expertise_submitted');
  Segment.track('Expertise submitted', data);
};
